<template minapp='mpx' xlang='wxml'>
   <es-drawer-bottom
    title="{{title}}"
    show="{{show}}"
    showDefaultNav
    bind:close="close"
    class="main"
    navbarStyle="{{curNavBarStyle}}"
    customStyle="{{curCustomStyle}}"
  >
    <view class="drawer-container">
      <view class="publicity">
        <view class="explain">
          <view class="ticket-title" wx:for="{{explainText}}" wx:key="index">
            <view>{{ item.title }}</view>
            <view class="ticket-title-cash">{{ item.case }} </view>
          </view>
          <!-- 退票手续费规则 -->
          <view class="rules">
            <view
              wx:for="{{handing_fee_detail}}"
              wx:key="inde"
              wx:class="{{ {rule:true,checked:item.status} }}"
            >
              <view class="time">{{item.key}}</view>
              <view class="handle">
                <view class="handle-text">{{item.value}}</view>
                <view class="handle-fee highlight">{{item.fee}}</view>
                <view class="highlight" wx:show="{{item.status}}">当前</view>
              </view>
            </view>
          </view>
          <view class="spring-festival-refund" wx:if="{{showSpringFestivalRefund}}">{{springFestivalRefund}}</view>
        </view>
        <tips-card
          title="退票说明"
          sideTitle="查看详情"
          sideIcon="{{true}}"
          sideColor="#1473FF"
          texts="{{refundTipTexts}}"
          bind:sideClick="onSideClick"
        />
      </view>
      <view class="footer">
        <view class="footer-left">
          <view class="foooter-left-text">预计退款金额</view>
          <view class="footer-left-amount">
            <text wx:if="{{total_refund >= 0}}">¥</text>
            <text class="amont-money">{{ total_refund }}</text>
          </view>
        </view>
        <view class="footer-right" bindtap="confirmRefund">确认退票</view>
      </view>
    </view>
   </es-drawer-bottom>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { innerRouter, pagePath } from '@/common/jump'
  import { trackEvent } from '@/common/track'
  import { getFinalPrice } from '@/utils/money'

  createComponent({
    props: {
      title: {
        type: String,
        value: '退票说明'
      },
      show: {
        type: Boolean,
        value: false
      },
      selectTicket: {
        type: Object,
        value: () => ([])
      },
      handlePrice: {
        type: Object,
        value: () => ({})
      },
      refundTipTexts: {
        type: Array,
        value: () => [
          '改签后的车票退票，距离发车时间48小时以上，铁路部门仍要收取5%退票手续费，具体退票金额以铁路部门实际退还的金额为准，此处仅展示预估金额。',
          '广深港跨境车票，具体退票金额以铁路部门实际退还的金额为准。',
          '退票手续费及最终退款金额以铁路部门实退为准，此处仅展示预估金额。',
          '如您已在车站办理退票业务，无需重复操作，退款会在 15 个工作日内自动退回。',
          '如果已经取出报销凭证，请在退票之日起 180 天内交回车站窗口，退款将在交回报销凭证后 7 个工作日内原路退回。'
        ]
      }
    },
    computed: {
      total_refund() {
        return this.formatPrice(this.handlePrice.total_refund)
      },
      handing_fee_detail() {
        return this.handlePrice?.handing_fee_detail ?? []
      },
      showSpringFestivalRefund() {
        return this.handlePrice?.festival_refund_rule_limit_show
      },
      explainText() {
        let _explainText = [
          {
            title: '车票',
            case: this.formatPrice(this.handlePrice.total_price, '¥')
          },
          {
            title: this.handlePrice.coupon_name,
            case: this.formatPrice(this.handlePrice.coupon_amount, `¥`)
          },
          {
            title: '预计手续费(铁路局收取)',
            case: '-' + this.formatPrice(this.handlePrice.total_handing_fee, '¥')
          }
        ]
        this.handlePrice.discount_handing_fee &&
          _explainText.push({
            title: '退改无忧手续费减免',
            case: this.formatPrice(this.handlePrice.discount_handing_fee, '¥')
          })
        return _explainText
      },
      curCustomStyle() {
        return {
          background: '#F0F1F4',
          height: '85vh'
        }
      },
      curNavBarStyle() {
        return {
          background: '#f0f1f4'
        }
      }
    },
    data() {
      return {
        position: 'bottom',
        isShow: true,
        springFestivalRefund: '改签或变更到站后的车票乘车日期在春运期间（1月26日至3月5日）的，退票按开车前不足24小时标准（按票面价格20%）核收退票费'
      }
    },
    methods: {
      formatPrice(price, pre = '') {
        if (price >= 0) {
          return `${pre}${getFinalPrice(price)}`
        } else {
          return price
        }
      },
      trackClick(module) {
        this.selectTicket?.ticket.forEach(ticket=>{
          const { status, order_id, ticket_id, order_type } = ticket || {}
          trackEvent('userteam_train_concancel_canpop_ck', 'UT-火车票-订单详情页-退票弹窗-点击', {
            status,
            order_id,
            ticket_id,
            module,
            login_type: order_type === 1 ? 'quick': '12306'
          })
        })
      },
      onSideClick() {
        this.trackClick('detail')
        this.close()
        innerRouter.push(pagePath().ICKETPURCHASENOTICE, {
          checkTabIndex: 'refund'
        })
      },
      close() {
        this.trackClick('close')
        this.$trigger('closeExplain')
      },
      confirmRefund() {
        this.trackClick('confirm')
        this.$trigger('confirmRefund')
      }
    }
  })
</script>

<style lang="stylus" scoped>
  .main
    /deep/ .es-navbar
      background-color #F0F1F4
    /deep/ .drawer-container
      overflow auto
  .drawer-container
    width 100vw
    background #F0F1F4
    border-radius 16px 16px 0 0
    display flex
    flex-direction column
    align-items center
    overflow auto
    .publicity
      box-sizing border-box
      width 100%
      display flex
      flex-direction column
      padding 0px 12px 97px
      .explain
        box-sizing border-box
        background #FFFFFF
        border-radius 8px
        padding 8px 12px 12px
        margin-bottom 10px
        .ticket-title
          display flex
          height 20px
          align-items center
          justify-content space-between
          font-family PingFangSC-Medium
          font-size 16px
          font-weight normal
          letter-spacing 0px
          color #000000
          margin 4px 0 12px
          &-cash
            color #1473FF
        .rules
          border-radius 8px
          box-sizing border-box
          border 1px solid rgba(0, 0, 0, 0.08)
          .rule
            height 34px
            display flex
            border-top 1px solid rgba(0, 0, 0, 0.08)
            font-family PingFangSC-Regular
            font-size 12px
            font-weight normal
            letter-spacing 0px
            color #666666
            &:first-child
              background rgba(231, 241, 255, 0.3)
              border none
              font-family PingFangSC-Medium
            &.checked
              background linear-gradient(270deg, #FFF4EE 0%, rgba(255, 255, 255, 0) 99%)
              border-right 2px solid #FF7D41
            .time
              width 180px
              height 100%
              flex none
              display inline-flex
              align-items center
              padding-left 12px
            .handle
              border-left 1px solid rgba(0, 0, 0, 0.08)
              height 100%
              flex 1
              display inline-flex
              align-items center
              justify-content space-between
              padding 0 12px
              &-text
                flex none
                margin-right 5px
              &-fee
                flex 1
              .highlight
                color #FF7D41
    .footer
      width 100%
      box-sizing border-box
      display flex
      background #ffffff
      position fixed
      bottom 0px
      height 85px
      padding 16px 16px 21px
      justify-content space-between
      align-items center
      .footer-left
        display flex
        align-items flex-end
        font-family PingFangSC-Medium
        font-size 12px
        font-weight normal
        line-height 14px
        color #333333
        .foooter-left-text
          margin-right 12px
        .footer-left-amount
          color #1473FF
          .amont-money
            font-size 22px
      .footer-right
        font-family PingFangSC-Medium
        font-size 16px
        font-weight normal
        line-height 19px
        text-align center
        letter-spacing 0px
        color #FFFFFF
        padding 13px 28px
        background-color #1473FF
        border-radius 8px
    .spring-festival-refund
      color #FF7D41
      font-size 12px
      background #FFF4EE
      border-radius 8px
      padding 8px 9px 9.5px
      margin-top 12px
      line-height 18px
</style>
<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'es-drawer-bottom': '@didi/es-mpx-ui/lib/drawer-bottom',
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'tips-card': '../tips-card'
    }
  }
</script>
